import styled from "styled-components";
import Info from "../../../components/Images/InfoIcon"

const DailyBonusStats = styled.p`
    font-size: 20px;
    font-weight: 600;
    line-height: 1.2;
    text-align: left;
    color: #54b585;
    margin-right: 4px;
    @media(max-width: 600px){
        font-size: 18px;
    }
`

const BonusStatsText = styled.div`
    font-size: 14px;
    line-height: 1.43;
    color: rgba(13, 21, 54, 0.4);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`

const BonusCautionBox = styled.div`
    margin: 16px 0px;
    padding: 12px 8px;
    border-radius: 4px;
    border: solid 1px rgba(6, 138, 226, 0.24);
    background-color: rgba(6, 138, 226, 0.08);
`

const BonusCautionText = styled.p`
    font-size: 14px;
    line-height: 1.43;
    color: #0350a2;
`
const BonusUpperDiv = styled.div`
    display: flex;
    gap: 8px;
    @media(max-width: 1250px){
        flex-direction : column;
    }
`
const InfoIcon = styled(Info)`
    width: 16px;
    height: 16px;
`

const SubHeading = styled.div`
    font-size: 16px;
    color: rgba(13, 21, 54, 0.8);
    margin-top: 8px;
    display: flex;
    align-items: center;
    gap: 3px;
    span {
      text-transform: uppercase;
      background-image: linear-gradient(
        -225deg,
        #F7737B 0%,
        #799E22 67%,
        #068AE2 100%
      );
      background-size: auto auto;
      background-clip: border-box;
      background-size: 200% auto;
      color: #fff;
      background-clip: text;
      text-fill-color: transparent;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      animation: textclip 2s linear infinite;
      display: inline-block;
      font-size: 16px;
      font-weight:600;
    }
    button {
        display: inline;
        background: rgba(6, 138, 226, 0.16);
        border-radius: 2px;
        font-size: 12px;
        color: #0350A2;
        font-weight: 700;
        border: none;
        outline: none;
        padding: 4px;
        margin-left: 3px;
        text-align: left;
        padding-left: 8px;
    }
    @media (max-width: 360px){
        font-size: 3.5vw;
    }
    @keyframes textclip {
      to {
        background-position: 200% center;
      }
    }
`



const PopupContainer = styled.div`
  position: relative;
  font-family: 'Inter', sans-serif;
  margin-top: 0px;
  transition: all 0.2s;
  max-height: 600px;
  overflow-y: scroll;
  img{
    width: 100%;
  }
  strong{
    font-weight: 700;
    color: rgba(13, 21, 54, 1.0);
  }
`

const PopupHeading = styled.h2`
  transition: all 0.2s;
  color: ${({isUserFromUS}) => isUserFromUS ? '#0350A2' : '#0d1536'};
  text-align: left;
  font-weight: 700;
  font-size: 18px;
  color: rgba(13, 21, 54, 0.65);
  font-family: 'Inter';
  margin-top: 10px;
  @media (max-width: 370px){
    font-size: 4.5vw;
  }
  @media (min-width: 425px){
    font-size: 20px;
  }
`

const PopupDescription = styled.p`
  font-weight: 400;
  font-size: 14px;
  color: rgba(13, 21, 54, 0.65);
  margin: 16px auto;
  font-family: 'Inter';
  line-height: 30px;
  span {
    font-weight: 700;
  }
`
const PopupRewardPoints = styled.div`
  background: rgba(242, 198, 2, 0.08);
  border: 1px solid rgba(242, 198, 2, 0.24);
  border-radius: 8px;
  font-weight: 400;
  font-size: 12px;
  color: rgba(13, 21, 54, 0.65);
  margin: 16px auto;
  font-family: 'Inter';
  padding: 8px;

  img {
    width: 20px;
    margin-right: 2px;
  }
  span {
    font-weight: 700;
  }
  ul {
    margin-left: 20px;
    margin-top: 4px;
    line-height: 30px;
  }
  @media (max-width: 370px){
    font-size: 3vw;
  }
  @media (min-width: 425px){
    font-size: 14px;
  }
`
const PopupTips = styled.div`
  background: rgba(6, 138, 226, 0.16);
  border: 1px solid rgba(84, 181, 133, 0.4);
  border-radius: 4px;
  font-weight: 400;
  font-size: 12px;
  line-height: 25px;
  color: rgba(13, 21, 54, 0.65);
  margin: 16px auto;
  font-family: 'Inter';
  padding: 10px;
  p {
    display: flex;
    align-items: center;
    font-family: 'Inter';
    font-weight: 700;
    font-size: 16px;
    color: rgba(13, 21, 54, 0.65);
  }
  img {
    width: 24px;
    margin-right: 5px;
  }
  
  span {
    font-weight: 700;
  }
  ol {
    margin-left: 20px;
    margin-top: 8px;
  }
  @media (min-width: 425px){
    font-size: 14px;
    p {
        font-size: 18px;
    }
  }
`
const PopupFeedBack = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: rgba(13, 21, 54, 0.65);
  img {
    width: 24px;
  }
  a {
    color: #068AE2;
    display: inline;
  }
`

const ClickHereText = styled.span`
  color: blue;
  cursor: pointer;
`

export {
    DailyBonusStats,
    BonusStatsText,
    BonusCautionBox,
    BonusCautionText,
    BonusUpperDiv,
    InfoIcon,
    SubHeading,
    PopupContainer,
    PopupHeading,
    PopupDescription,
    PopupRewardPoints,
    PopupTips,
    PopupFeedBack,
    ClickHereText
}